import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Select, Button, Checkbox, DatePicker, Table, Modal, Space, Tooltip, Dropdown, Spin } from "antd";
import "./sales_order_invoice.css";
import withSalesOrderInvoiceLogic, { SalesOrderInvoiceLogicProps, DataType, convertStatusToString } from "../../components/hoc_so_invoice";
import BrowserPL from "./so_invoice_browser_packing_list";
import InvoiceCustomerBrowser from "./so_invoice_browser_customer";
import { MdRefresh } from "react-icons/md";
import { IoPrintSharp } from "react-icons/io5";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FaPlusCircle } from "react-icons/fa";

const SalesOrderInvoiceUI: React.FC<SalesOrderInvoiceLogicProps> = ({
    transformStyle,
    showContentBillTo,
    setShowContentBillTo,
    showContentTotal,
    setShowContentTotal,
    showContentTax,
    setShowContentTax,
    checkedValue,
    handleCheckboxChange,
    onDateChange,
    onChange,
    onChangeProvince,
    onChangeVatItemCategory,
    columns,
    rowSelection,
    dataSource,
    brandOptions,
    loadingBrands,
    termsOfPaymentOptions,
    loadingTermsOfPayment,
    vatTransactionOptions,
    loadingVatTransactions,
    showPackingListModal,
    setShowPackingListModal,
    showCustomerModal,
    setShowCustomerModal,
    provinceOptions,
    loadingProvinces,
    regencyOptions,
    loadingRegencies,
    kecamatanOptions,
    loadingKecamatans,
    onChangeRegency,
    onChangeKecamatan,
    kelurahanOptions,
    loadingKelurahans,
    postalCode,
    onChangeKelurahan,
    form,
    onSelectCustomer,
    onSelectPackingList,
    onChangeTermsOfPayment,
    isPackingListNoDisabled,
    isPackingListNoReadOnly,
    isSearchPLButtonDisabled,
    isVoidDisabled,
    autosaveStatus,
    onVoid,
    voidReason,
    setVoidReason,
    isReasonModalOpen,
    setIsReasonModalOpen,
    handleReasonSubmit,
    onSubmit,
    onPrint,
    isPrinting,
    isProcessing,
    dealerReCodeDisplay,
    isFormDisabled,
    onNew,
    onRefreshData,
    isReportModalOpen,
    handleReportModalCancel,
    isPrintDisabled
}) => {
    const currentStatus = Form.useWatch('status', form);
    const currentPackingListNo = Form.useWatch('packing_list_no', form);
    const Refreshbtn = MdRefresh as React.ComponentType<any>;
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
    const Newbtn = FaPlusCircle as React.ComponentType<any>;

    return (
        <Spin spinning={isProcessing || isPrinting} size="large" tip="Memproses Transaksi, Harap Tunggu...">
            <div id="iau9" style={transformStyle}>
                <div className="gjs-grid-row" id="iwk7k">
                    <div className="gjs-grid-column" id="ibwrf">
                        <Breadcrumb
                            items={[
                                {
                                    title: <HomeOutlined />,
                                },
                                {
                                    href: "#/dashboard/browser_sales_order_invoice",
                                    title: (
                                        <>
                                            <span>Data Sales Order Invoice</span>
                                        </>
                                    ),
                                },
                                {
                                    title: "Sales Order Invoice",
                                },
                            ]}
                        />
                    </div>
                </div>

                <div className="gjs-grid-row" id="uuuuriasj">
                    <div className="gjs-grid-column" id="iiioedjsk">
                        <Button className="pr-button" onClick={onNew} disabled={autosaveStatus === 'processing'}>
                            <Newbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            New
                        </Button>
                        <Button
                            className="pr-button"
                            onClick={onSubmit}
                            disabled={autosaveStatus === 'processing' || (currentStatus !== 'Draft' && currentStatus !== '1' && currentStatus !== 1)}
                        >
                            <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Submit
                        </Button>
                        <Button
                            className="pr-button"
                            onClick={onVoid}
                            disabled={autosaveStatus === 'processing' || ![1, '1', 'Draft', 2, '2', 'Active'].includes(currentStatus)}
                        >
                            <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Void
                        </Button>
                        <Button className="pr-button" onClick={onPrint} loading={isPrinting} disabled={autosaveStatus === 'processing' || isPrintDisabled || isProcessing}>
                            <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Print
                        </Button>
                        <Button className="gr-button" onClick={onRefreshData} disabled={autosaveStatus === 'processing' || !currentPackingListNo || (currentStatus !== 'Draft' && currentStatus !== '1' && currentStatus !== 1)}>
                            <Refreshbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Refresh Data
                        </Button>
                        <Space style={{ marginLeft: '10px' }}>
                            {autosaveStatus === 'processing' && (
                                <Tooltip title="Autosave sedang berjalan...">
                                    <LoadingOutlined style={{ color: '#1890ff' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'error' && (
                                <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                    <WarningOutlined style={{ color: '#ff4d4f' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'stopped' && (
                                <Tooltip title="Autosave Stopped">
                                    <StopOutlined style={{ color: '#bfbfbf' }} />
                                </Tooltip>
                            )}
                            {autosaveStatus === 'idle' && (
                                <Tooltip title="Autosave berhasil.">
                                    <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                </Tooltip>
                            )}
                        </Space>
                    </div>
                </div>

                <div className="gjs-grid-row" id="imlgo">
                    <div className="gjs-grid-column" id="i1mou">
                        <Form
                            layout="horizontal"
                            style={{ maxWidth: 530 }}
                            labelCol={{ style: { width: '230px', textAlign: "left" } }}
                            wrapperCol={{ style: { width: '290px' } }}
                            className="custom-info-purchase-request"
                            form={form}
                            disabled={isFormDisabled}
                        >
                            <Form.Item
                                label="Status"
                                name="status"
                                style={{
                                    marginBottom: "5px",
                                }}
                                getValueProps={(value) => ({ value: convertStatusToString(value) })}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Trans ID"
                                name="trans_id"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Invoice No"
                                name="invoice_no"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Invoice Date"
                                name="invoice_date"
                                style={{
                                    marginBottom: "5px", width: "75%",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Invoice Due Date"
                                name="invoice_due_date"
                                style={{
                                    marginBottom: "5px", width: "75%",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Tax Invoice No."
                                name="tax_invoice_no"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Tax Invoice Date"
                                name="tax_invoice_date"
                                style={{
                                    marginBottom: "5px", width: "75%",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Brand"
                                name="brand"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Brand"
                                    optionFilterProp="label"
                                    onChange={onChange}
                                    options={brandOptions}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="VAT Item Category"
                                name="vat_item_category"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select VAT Item Category"
                                    optionFilterProp="label"
                                    onChange={onChangeVatItemCategory}
                                    options={[
                                        { value: "", label: "-- Empty ---" },
                                        { value: "BM", label: "Barang Mewah" },
                                        { value: "BMN", label: "Barang Non Mewah" },
                                    ]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Packing List No"
                                name="packing_list_no"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <Input
                                        placeholder=""
                                        style={{
                                            width: "90%",
                                        }}
                                        readOnly={isPackingListNoReadOnly}
                                        disabled={isPackingListNoDisabled}
                                        value={form.getFieldValue('packing_list_no')}
                                    />
                                    <Button
                                        type="primary"
                                        id="so_invoice_browser_packing_list"
                                        icon={
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                style={{
                                                    width: "40px",
                                                    height: "20px",
                                                }}
                                            >
                                                <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                    clipRule="evenodd"
                                                />
                                                <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                            </svg>
                                        }
                                        onClick={() => setShowPackingListModal(true)}
                                        disabled={isSearchPLButtonDisabled}
                                    />
                                </div>
                            </Form.Item>
                            <Form.Item
                                label="Profit Center"
                                name="profit_center"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Warehouse"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input value={dealerReCodeDisplay} placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Transaction Type"
                                name="transaction_type"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item
                                label="Event No"
                                name="event_no"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Required!',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Event No"
                                    optionFilterProp="label"
                                    onChange={onChange}
                                    options={[
                                        { value: "", label: "-- Empty --" },
                                        { value: "01", label: "3rd Invoice Part & Acc" },
                                    ]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Credit Note Down Payment No"
                                name="credit_note"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Customer"
                                name="customer"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Sales Order No"
                                name="sales_order_no"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Salesman Name"
                                name="sales_man"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="PO Customer No"
                                name="po_customer_no"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Bank Account 1"
                                name="bank1"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Bank Account 2"
                                name="bank2"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Payment Type"
                                name="payment_type"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Payment Type"
                                    optionFilterProp="label"
                                    onChange={onChange}
                                    options={[
                                        { value: "1", label: "Cash" },
                                        { value: "2", label: "Cheque" },
                                        { value: "3", label: "Credit Card" },
                                        { value: "4", label: "Debit Card" },
                                        { value: "5", label: "E-Banking" },
                                        { value: "6", label: "Giro" },
                                        { value: "7", label: "Other" },
                                        { value: "8", label: "Transfer" },
                                        { value: "9", label: "Travel Cheque" },
                                        { value: "10", label: "Voucher" },
                                    ]}
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Remark"
                                name="remar"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input.TextArea rows={4} placeholder="Enter your remarks here..." />
                            </Form.Item>

                            <div className="grid-2">
                                <Form.Item
                                    label="Bill To"
                                    style={{
                                        marginBottom: "0px",
                                    }}
                                >
                                    <div
                                        style={{
                                            gap: "0px",
                                            marginTop: "0px",
                                        }}
                                    >
                                        <Checkbox
                                            onChange={(e) => setShowContentBillTo(e.target.checked)}
                                        >
                                            Show
                                        </Checkbox>
                                    </div>
                                </Form.Item>

                                {showContentBillTo && (
                                    <>
                                        <Form.Item
                                            label="Customer Code"
                                            name="customer_code"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                                <Input
                                                    placeholder=""
                                                    style={{
                                                        width: "90%",
                                                    }}
                                                    value={form.getFieldValue('customer_code')}
                                                    readOnly
                                                />
                                                <Button
                                                    type="primary"
                                                    id="browser_cs"
                                                    icon={
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                            style={{
                                                                width: "40px",
                                                                height: "20px",
                                                            }}
                                                        >
                                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                                clipRule="evenodd"
                                                            />
                                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                                        </svg>
                                                    }
                                                    onClick={() => setShowCustomerModal(true)}
                                                />
                                            </div>
                                        </Form.Item>
                                        <Form.Item
                                            label="Customer Type"
                                            name="customer_type"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="Title Prefix"
                                            name="title_prefix"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="Name"
                                            name="name_bill"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="Title Suffix"
                                            name="title_suffix"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="ID Type"
                                            name="id_type"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select ID Type"
                                                optionFilterProp="label"
                                                onChange={onChange}
                                                options={[
                                                    { value: "01", label: "KTP" },
                                                    { value: "02", label: "NPWP" },
                                                ]}
                                                style={{ width: "100%" }}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Id No"
                                            name="id_no"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="Billable To"
                                            name="billable_to"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select Billable To"
                                                optionFilterProp="label"
                                                onChange={onChange}
                                                options={[
                                                    { value: "", label: "-- Empty --" },
                                                    { value: "1", label: "Billing" },
                                                    { value: "2", label: "Correspondence" },
                                                    { value: "3", label: "Home" },
                                                    { value: "4", label: "ID" },
                                                    { value: "5", label: "Office" },
                                                    { value: "6", label: "Tax" },
                                                ]}
                                                style={{ width: "100%" }}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Address"
                                            name="address"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input.TextArea rows={4} placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="Provinsi"
                                            name="provinsi"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select Provinsi"
                                                optionFilterProp="label"
                                                onChange={onChangeProvince}
                                                options={provinceOptions}
                                                loading={loadingProvinces}
                                                style={{ width: "100%" }}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Kabupaten"
                                            name="kabupaten"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select Kabupaten"
                                                optionFilterProp="label"
                                                onChange={onChangeRegency}
                                                options={regencyOptions}
                                                loading={loadingRegencies}
                                                style={{ width: "100%" }}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Kecamatan"
                                            name="kecamatan"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select Kecamatan"
                                                optionFilterProp="label"
                                                onChange={onChangeKecamatan}
                                                options={kecamatanOptions}
                                                loading={loadingKecamatans}
                                                style={{ width: "100%" }}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="kelurahan"
                                            name="kelurahan"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select Kelurahan"
                                                optionFilterProp="label"
                                                onChange={onChangeKelurahan}
                                                options={kelurahanOptions}
                                                loading={loadingKelurahans}
                                                style={{ width: "100%" }}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Kode Pos"
                                            name="kode_pos"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input
                                                placeholder=""
                                                style={{
                                                    width: "40%",
                                                }}
                                                value={postalCode}
                                                readOnly
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Phone No"
                                            name="phone_no"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input
                                                placeholder=""
                                                style={{
                                                    width: "80%",
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Fax No"
                                            name="fax_no"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input
                                                placeholder=""
                                                style={{
                                                    width: "80%",
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Terms Of Payment"
                                            name="top"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select TOP"
                                                optionFilterProp="label"
                                                onChange={onChangeTermsOfPayment}
                                                options={termsOfPaymentOptions}
                                                loading={loadingTermsOfPayment}
                                                style={{ width: "100%" }}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Bill Code"
                                            name="bill_code"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="Tax Invoice Type"
                                            name="tax_invoice_type"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" readOnly />
                                        </Form.Item>
                                    </>
                                )}
                            </div>


                            <div className="grid-2">
                                <Form.Item
                                    label="Tax"
                                    style={{
                                        marginBottom: "0px",
                                    }}
                                >
                                    <div
                                        style={{
                                            gap: "0px",
                                            marginTop: "0px",
                                        }}
                                    >
                                        <Checkbox
                                            onChange={(e) => setShowContentTax(e.target.checked)}
                                        >
                                            Show
                                        </Checkbox>
                                    </div>
                                </Form.Item>

                                {showContentTax && (
                                    <>
                                        <Form.Item
                                            label="NPWP"
                                            name="npwp"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="NPWP Date"
                                            name="npwp_date"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <DatePicker
                                                onChange={onDateChange}
                                                format="DD/MM/YYYY"
                                                placeholder="Date & Time"
                                                style={{ width: "50%", fontSize: "14px" }}
                                                popupStyle={{ fontSize: "12px" }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="PKP Type"
                                            name="pkp_type"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    gap: "15px",
                                                    marginTop: "10px",
                                                    display: "flex",
                                                }}
                                            >
                                                <Checkbox
                                                    checked={checkedValue === "Yes"}
                                                    onChange={() => handleCheckboxChange("Yes")}
                                                >
                                                    Yes
                                                </Checkbox>
                                                <Checkbox
                                                    checked={checkedValue === "No"}
                                                    onChange={() => handleCheckboxChange("No")}
                                                >
                                                    No
                                                </Checkbox>
                                            </div>
                                        </Form.Item>
                                        <Form.Item
                                            label="PKP"
                                            name="pkp"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="PKP Date"
                                            name="pkp_date"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <DatePicker
                                                onChange={onDateChange}
                                                format="DD/MM/YYYY"
                                                placeholder="Date & Time"
                                                style={{ width: "50%", fontSize: "14px" }}
                                                popupStyle={{ fontSize: "12px" }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Transaction Code"
                                            name="transaction_code"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select Transaction Code"
                                                optionFilterProp="label"
                                                onChange={onChange}
                                                options={vatTransactionOptions}
                                                loading={loadingVatTransactions}
                                                style={{ width: "100%" }}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Name"
                                            name="name_tax"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" />
                                        </Form.Item>
                                        <Form.Item
                                            label="Address"
                                            name="address_tax"
                                        >
                                            <Input.TextArea rows={4} placeholder="" />
                                        </Form.Item>
                                    </>
                                )}
                            </div>


                            <div className="grid-2">
                                <Form.Item
                                    label={<span style={{ fontWeight: "bold" }}>TOTAL</span>}
                                    style={{
                                        marginBottom: "0px",
                                    }}
                                >
                                    <div
                                        style={{
                                            gap: "0px",
                                            marginTop: "0px",
                                        }}
                                    >
                                        <Checkbox
                                            onChange={(e) => setShowContentTotal(e.target.checked)}
                                            style={{ fontWeight: "300" }}
                                        >
                                            Show
                                        </Checkbox>
                                    </div>
                                </Form.Item>


                                {showContentTotal && (
                                    <>
                                        <Form.Item
                                            label="Item Total"
                                            name="item_total"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" readOnly />
                                        </Form.Item>
                                        <Form.Item
                                            label="Item Discount"
                                            name="item_discount"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" readOnly />
                                        </Form.Item>
                                        <Form.Item
                                            label="Total"
                                            name="total"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" readOnly />
                                        </Form.Item>
                                        <Form.Item
                                            label="Down Payment"
                                            name="dp"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" readOnly />
                                        </Form.Item>
                                        <Form.Item
                                            label="Vat"
                                            name="vat"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" readOnly />
                                        </Form.Item>
                                        <Form.Item
                                            label="Invoice Amount"
                                            name="invoice_amount"
                                            style={{
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <Input placeholder="" readOnly />
                                        </Form.Item>
                                    </>
                                )}
                            </div>
                        </Form>
                    </div>
                </div>
                <div className="gjs-grid-row" id="iwes3">
                    <div className="gjs-grid-column" id="i5sei">
                        <Table<DataType>
                            rowSelection={rowSelection}
                            columns={columns}
                            style={{ paddingRight: '30px' }}
                            dataSource={dataSource}
                            scroll={{ x: 900 }}
                            className="table-gr"
                        />
                    </div>
                </div>
                <Modal
                    title="Packing List Browser"
                    open={showPackingListModal}
                    onCancel={() => setShowPackingListModal(false)}
                    footer={null}
                    width="fit-content"
                >
                    <BrowserPL onSelectPackingList={onSelectPackingList} />
                </Modal>
                <Modal
                    title="Customer Browser"
                    open={showCustomerModal}
                    onCancel={() => setShowCustomerModal(false)}
                    footer={null}
                    width="1200px"
                >
                    <InvoiceCustomerBrowser onSelectCustomer={onSelectCustomer} />
                </Modal>
                <Modal
                    title="Alasan Pembatalan"
                    open={isReasonModalOpen}
                    onOk={handleReasonSubmit}
                    onCancel={() => setIsReasonModalOpen(false)}
                    okText="Submit"
                    cancelText="Batal"
                >
                    <div style={{ padding: "10px 0" }}>
                        <Input.TextArea
                            rows={3}
                            value={voidReason}
                            onChange={(e) => {
                                const prefix = "Void Invoice";
                                const val = e.target.value;
                                if (val.startsWith(prefix)) {
                                    setVoidReason(val);
                                }
                            }}
                        />
                    </div>
                </Modal>
                <Modal
                    title="Print Preview - Sales Order Invoice"
                    open={isReportModalOpen}
                    onCancel={handleReportModalCancel}
                    footer={null}
                    width={1100}
                    destroyOnClose
                >
                    <div id="sti-viewer-container" style={{ width: '100%', minHeight: '75vh' }} />
                </Modal>
            </div>
        </Spin>
    );
};


const SalesOrderInvoice = withSalesOrderInvoiceLogic(SalesOrderInvoiceUI);
export default SalesOrderInvoice;
